const replaceHTMLEntites = (text: string): string => {
  const entitesRegex = /&(nbsp|amp|quot|lt|gt);/g;
  const dictionaryEntites: any = {
    nbsp: ' ',
    amp: '&',
    quot: '"',
    lt: '<',
    gt: '>',
  };
  const textClear = text.replace(entitesRegex, (match, entity) => dictionaryEntites[entity]);

  return textClear;
};
export default replaceHTMLEntites;
